import { render } from "./SponsorsList.vue?vue&type=template&id=ce42061a"
import script from "./SponsorsList.vue?vue&type=script&lang=ts"
export * from "./SponsorsList.vue?vue&type=script&lang=ts"
script.render = render

export default script